module.exports = __webpack_public_path__ + "img/eg-25-01.0abffea5.jpg";